<div class="card settings-page">
  <div class="action-panel">
    <button
      *appHasRole="['Admin', 'Manager', 'Preparer']"
      type="button"
      class="btn btn-primary d-flex align-items-center gap-2"
      [disabled]="editOrganisationModalOpened || isLoading()"
      (click)="openEditOrganisationModal()"
    >
      <i class="icon ic-edit-20"></i>
      <span>Edit Organisation</span>
    </button>
  </div>

  <div>
    @if (!isLoading()) {
      <div class="organisation-details-part">
        <div class="organisation-details-item">
          <div class="form-group">
            <label class="title mb-1">Account Name</label>
            <div class="property">
              <div appCopy>{{ organisation.name | defaultValue }}</div>
            </div>
          </div>

          <div class="form-group">
            <label class="title mb-1">Email Address</label>
            <div class="property">
              <div appCopy>{{ (organisation.email ?? '') | defaultValue }}</div>
            </div>
          </div>

          <div class="form-group">
            <label class="title mb-1">Phone Number</label>
            <div class="property">
              <div appCopy>{{ (organisation.phone ?? '') | phone | defaultValue }}</div>
            </div>
          </div>
        </div>

        <div class="organisation-details-item">
          <div class="form-group">
            <label class="title mb-1">Address</label>
            <div class="property">
              <div appCopy>{{ organisation.address?.normalizedFullAddress | defaultValue }}</div>
            </div>
          </div>

          <div class="form-group">
            <label class="title mb-1">Website</label>

            @if (organisation.website) {
              <a
                class="property website-url"
                target="_blank"
                [href]="organisation.website"
              >
                {{ organisation.website }}
              </a>
            } @else {
              <div class="property">
                <div appCopy>{{ organisation.website | defaultValue }}</div>
              </div>
            }
          </div>
        </div>

        <div class="organisation-details-item">
          <div class="form-group">
            <label class="title mb-1">Primary Contact</label>
            <div class="property">
              <div appCopy>{{ primaryContactLabel | defaultValue }}</div>
            </div>
          </div>

          <div class="form-group">
            <label class="title mb-1">Billing Contact</label>
            <div class="property">
              <div appCopy>{{ billingContactLabel | defaultValue }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="subscription-part">
        <div class="part-title">Current Subscription</div>

        <div class="subscription-part-grid">
          <div class="form-group">
            <label class="title mb-1">Current Subscription</label>
            <div class="property">
              <div appCopy>{{ '' | defaultValue }}</div>
            </div>
          </div>
        </div>
      </div>

<!--      <div class="organisation-settings-part" *appHasRole="['superuser']">-->
<!--        <div class="part-title">Organisation Settings (SuperUser)</div>-->
<!--        <div class="organisation-settings-part-grid">-->
<!--          <div class="form-group">-->
<!--            <label class="title mb-1">Individual Verificatoin ID</label>-->
<!--            <div-->
<!--              class="property"-->
<!--              (click)="changeVerificationEnabledValue()"-->
<!--            >-->
<!--              {{ (organisationSettings?.individualVerificationEnabled ? 'Yes' : 'No') | defaultValue }}-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    }

    <app-loader minHeight="200" [loading]="isLoading()"/>
  </div>
</div>
